import { Subscription } from 'rxjs';
import {
  DataLossService,
  AccessibilityService,
  LoaderService
} from '@shared/services';
import {
  SHOW_SORT_OPTIONS,
  SHOW_EXCLUSION_OPTIONS,
  exclusionCategoryEnum
} from '@exclusionmodule/constants';
import {
  AfterContentInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  AfterContentChecked,
  AfterViewInit,
  inject
} from '@angular/core';
import { pupilModel } from '@exclusionmodule/models';
import { BASE_ENDPOINT } from '@shared/properties';
import {
  ApiServiceService,
  MessagingService,
  NotificationService
} from '@oneeducation/app-core';
import { DataSortService } from '@shared/services';
import { propertyTypeEnum, sortOrderEnum } from '@shared/models';
import { ChangeDetectorRef } from '@angular/core';
import { Table } from 'primeng/table';
import { Select } from 'primeng/select';

@Component({
  selector: 'app-view-pupil-list',
  templateUrl: './view-pupil-list.component.html',
  standalone: false
})
export class ViewPupilListComponent
  implements
    OnInit,
    OnDestroy,
    AfterContentInit,
    AfterContentChecked,
    AfterViewInit
{
  private apiService = inject(ApiServiceService);
  private notificationService = inject(NotificationService);
  private dataSortService = inject(DataSortService);
  private cdRef = inject(ChangeDetectorRef);
  private dataLossService = inject(DataLossService);
  private messagingService = inject(MessagingService);
  private accessibilityService = inject(AccessibilityService);
  private elementRef = inject(ElementRef);
  private loaderService = inject(LoaderService);

  @ViewChild('inputSearchByUPNorName') inputSearchByUPNorName: ElementRef;
  @ViewChild('allPupilList') allPupilList: Table;
  @ViewChild('sortOptionsDropDown') sortOptionsDropDown: Select;
  @ViewChild('showDropDown') showDropDown: Select;
  displayPupilList = true;
  selectedPupil: pupilModel[];
  pupils: pupilModel[];
  allPupils: pupilModel[];
  schoolId: number;
  headerText: string;
  showSortOptions;
  showExclusionOptions;
  selectedExclusionOptions: string;
  selectedSortByOptions: string;
  searchByUPNOrName: string;
  propertyName: string;
  sortOrder: sortOrderEnum;
  propertyType: propertyTypeEnum;
  noPupilFoundMessage = false;
  isCreateExclusion = false;
  alertSubscription: Subscription;
  schoolName: string;
  readonly ENTER_KEY: number = 13;
  isLoading: boolean;

  constructor() {
    this.alertSubscription = this.messagingService
      .getAlert()
      .subscribe((arg) => {
        if (arg.value && this.isValidCategory(arg.value) != -1) {
          this.getPupilList();
        }
      });
  }

  ngOnInit(): void {
    setTimeout(() => {
      {
        if (this.inputSearchByUPNorName) {
          this.inputSearchByUPNorName.nativeElement.focus();
        }
      }
    }, 0);
    this.headerText = 'Pupils at';
    this.showSortOptions = SHOW_SORT_OPTIONS;
    this.showExclusionOptions = SHOW_EXCLUSION_OPTIONS;
    this.defaultDropDownValue();

    this.loaderService.isLoading.subscribe((loading) => {
      this.isLoading = loading;
    });
  }

  ngOnDestroy() {
    this.alertSubscription.unsubscribe();
  }

  changeExclusionOptions(event) {
    this.selectedExclusionOptions = event.value;
    this.searchText();
  }

  isValidCategory(category) {
    return Object.keys(exclusionCategoryEnum).findIndex(
      (key) =>
        category.toLowerCase() === exclusionCategoryEnum[key].toLowerCase()
    );
  }

  private filterBy(criteria: string) {
    this.pupils = this.allPupils;
    if (criteria === 'PupilswithExclusions') {
      this.pupils = this.pupils.filter(
        (a) => a.lastExclusionDate && !a.isOffRoll
      );
    } else if (criteria == 'OffRolledPupilsWithExclusion') {
      this.pupils = this.pupils.filter((a) => a.isOffRoll);
    } else if (criteria == 'AllPupils') {
      this.pupils = this.pupils.filter((a) => !a.isOffRoll);
    }
    this.noPupilFoundMessage = this.pupils.length > 0 ? false : true;
    this.sortBy(this.selectedSortByOptions);
  }

  changeSortyByOptions(event) {
    this.selectedSortByOptions = event.value;
    this.searchText();
  }

  private sortBy(option: string) {
    switch (option) {
      case 'SortByNameAZ':
        this.propertyName = 'studentName';
        this.sortOrder = sortOrderEnum.ascending;
        this.propertyType = propertyTypeEnum.string;
        break;
      case 'SortByNameZA':
        this.propertyName = 'studentName';
        this.sortOrder = sortOrderEnum.descending;
        this.propertyType = propertyTypeEnum.string;
        break;
      case 'SortbyDaysExcludedTermLeastMost':
        this.propertyName = 'excludedDaysInCurrentTerm';
        this.sortOrder = sortOrderEnum.ascending;
        this.propertyType = propertyTypeEnum.number;
        break;
      case 'SortbyDaysExcludedTermMostLeast':
        this.propertyName = 'excludedDaysInCurrentTerm';
        this.sortOrder = sortOrderEnum.descending;
        this.propertyType = propertyTypeEnum.number;
        break;
      case 'MostRecentlyExcluded':
        this.propertyName = 'lastExclusionDate';
        this.sortOrder = sortOrderEnum.descending;
        this.propertyType = propertyTypeEnum.date;
        break;
      default:
        break;
    }

    this.dataSortService.sortData(
      this.pupils,
      this.propertyName,
      this.propertyType,
      this.sortOrder
    );
  }

  private getPupilList() {
    this.noPupilFoundMessage = false;
    this.apiService
      .getAll<
        pupilModel[]
      >(BASE_ENDPOINT.GetSchoolStudents.replace('{baseId}', this.schoolId?.toString()), '')
      .subscribe({
        next: (x: any) => {
          this.allPupils = x.student;
          this.schoolName =
            this.allPupils[0] !== null && this.allPupils[0] !== undefined
              ? this.allPupils[0].base
              : '';
          this.filterBy(this.selectedExclusionOptions);
          this.sortBy(this.selectedSortByOptions);
          if (this.pupils.length == 0) {
            this.noPupilFoundMessage = true;
          }
        },
        error: (x: any) => {
          if (x.error.statusCode === 404) {
            this.noPupilFoundMessage = true;
          } else {
            this.notificationService.showError('Error getting students');
          }
          this.pupils = [];
          this.allPupils = [];
        }
      });
  }

  schoolChange(event) {
    if (this.schoolId !== event.value) {
      this.schoolId = event.value;
      this.searchByUPNOrName = '';
      this.getPupilList();
    }
  }

  private defaultDropDownValue() {
    this.selectedSortByOptions = 'MostRecentlyExcluded';
    this.selectedExclusionOptions = 'PupilswithExclusions';
  }
  searchText() {
    let filteredResult;

    this.filterBy(this.selectedExclusionOptions);
    if (this.searchByUPNOrName && this.searchByUPNOrName.trim() !== '') {
      filteredResult = this.pupils.filter(
        (x) =>
          x.studentName
            .toLowerCase()
            .includes(this.searchByUPNOrName.toLowerCase()) ||
          x.upn?.toLowerCase().includes(this.searchByUPNOrName.toLowerCase())
      );

      if (filteredResult.length > 0) {
        this.pupils = filteredResult;
      } else {
        this.pupils = [];
        this.noPupilFoundMessage = true;
      }
    }
  }

  redirectToStudSummaryPage(pupil: any) {
    this.hidePupilList(pupil);
    this.isCreateExclusion = false;
    return false;
  }

  isPermOrAperExclusionExist(pupil: pupilModel): boolean {
    if (
      pupil?.lastExclusionCategory?.toUpperCase() == 'PERMANENT' ||
      (pupil?.lastExclusionCategory?.toUpperCase() ==
        'APPEAL UPHELD BUT PUPIL NOT RE' &&
        pupil?.lastExclusionDate <= new Date())
    ) {
      return true;
    }

    return false;
  }

  redirectToCreateExclusion(pupil: any) {
    this.hidePupilList(pupil);
    this.isCreateExclusion = true;
    return false;
  }

  hidePupilList(pupil: any) {
    this.selectedPupil = pupil;
    this.displayPupilList = false;
  }

  displaypupilList() {
    this.searchText();
    this.displayPupilList = true;
  }

  ngAfterContentInit() {
    this.cdRef.detectChanges();
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadHandler($event) {
    if (this.canDeactivate()) {
      $event.returnValue = true;
    }
  }

  canDeactivate() {
    return this.dataLossService.isDirty();
  }

  ngAfterViewInit(): void {
    this.setLableListBoxPaginator();
  }

  private setAttributesForAlertBox() {
    if (this.elementRef) {
      this.accessibilityService.setAttributesForAlertBox(this.elementRef);
    }
  }

  ngAfterContentChecked(): void {
    this.setTablePaginationControlsTitle();
    this.setAttributesForAlertBox();
    this.setDropdownAttributes();
    this.setAccessibleNameForShowPeopleList();
    this.setAccessibleNameForSortByList();
    this.setAccessibleNameForGridPaginationMenu();
    this.setLandmarkRoleForDropdowns();
    this.removeRoleAttributeForDropDowns();
    this.removeAriaExpandedAttributeForDropDowns();
  }

  // Set attributes for grid pagination dropdown
  private setAccessibleNameForGridPaginationMenu() {
    if (this.allPupilList) {
      this.accessibilityService.setAccessibleNameForGridPaginationMenu(
        this.allPupilList,
        'Select number of student records to view'
      );
    }
  }

  // Set attributes for sort by dropdown
  private setAccessibleNameForSortByList() {
    if (this.sortOptionsDropDown) {
      this.accessibilityService.setAccessibleNameForDropdownMenuButton(
        this.sortOptionsDropDown,
        'Sort list of pupil by'
      );
    }
  }

  // Set attributes for show people dropdown
  private setAccessibleNameForShowPeopleList() {
    if (this.showDropDown) {
      this.accessibilityService.setAccessibleNameForDropdownMenuButton(
        this.showDropDown,
        'Filter list of pupil by'
      );
    }
  }

  // Set the properties of the dropdown
  private setDropdownAttributes() {
    // Set the properties of the sort by dropdown
    if (this.sortOptionsDropDown) {
      const props = new Map<string, string>();
      props.set('title', 'Sort options');
      this.accessibilityService.setDropDownItemsAttributes(
        this.sortOptionsDropDown,
        props
      );
    }
    // Set the properties of the show dropdown
    if (this.showDropDown) {
      const props = new Map<string, string>();
      props.set('title', 'Show exclusions');
      this.accessibilityService.setDropDownItemsAttributes(
        this.showDropDown,
        props
      );
    }
  }

  private setTablePaginationControlsTitle() {
    this.accessibilityService.setTablePaginationControlsTitle(
      this.allPupilList,
      'Select number of student records to view'
    );
  }

  private setLableListBoxPaginator() {
    const attributeMap = new Map();
    attributeMap.set('aria-label', 'Pages List');
    this.accessibilityService.setListBoxTableAttributes(
      this.allPupilList,
      attributeMap
    );
  }

  private onRowSelect(event) {
    if (event.originalEvent.keyCode === this.ENTER_KEY) {
      this.redirectToStudSummaryPage(event.data);
    }
  }

  // Ensures all page content is contained by landmarks
  private setLandmarkRoleForDropdowns() {
    if (this.showDropDown) {
      this.accessibilityService.setLandmarkRoleForDropDown(this.showDropDown);
    }
    if (this.sortOptionsDropDown) {
      this.accessibilityService.setLandmarkRoleForDropDown(
        this.sortOptionsDropDown
      );
    }
  }

  // Ensures role attribute has an appropriate value for the element
  private removeRoleAttributeForDropDowns() {
    if (this.showDropDown) {
      this.accessibilityService.removeRoleAttributeForDropDown(
        this.showDropDown
      );
    }
    if (this.sortOptionsDropDown) {
      this.accessibilityService.removeRoleAttributeForDropDown(
        this.sortOptionsDropDown
      );
    }
    if (this.allPupilList) {
      this.accessibilityService.removeRoleAttributeForDropDown(
        this.allPupilList
      );
    }
  }

  // Remove aria -expanded attribute
  private removeAriaExpandedAttributeForDropDowns() {
    if (this.showDropDown) {
      this.accessibilityService.removeAriaExpandedAttribute(this.showDropDown);
    }
    if (this.sortOptionsDropDown) {
      this.accessibilityService.removeAriaExpandedAttribute(
        this.sortOptionsDropDown
      );
    }
    if (this.allPupilList) {
      this.accessibilityService.removeAriaExpandedAttribute(this.allPupilList);
    }
  }
}
